import { Tooltip } from "./Tooltip";

export function Avatar({ user, big=false }) {
  
  const avatarUrl = () => {
    return `/api/users/avatar/${user.id}?token=` + localStorage.getItem('token');
  };
  
  const colorClasses = [
    'bg-red-500', 'bg-blue-500', 'bg-green-500',
    'bg-yellow-500', 'bg-purple-500', 'bg-pink-500',
    'bg-indigo-500', 'bg-teal-500', 'bg-orange-500'
  ];

  const getColor = () => {
    return colorClasses[(user?user.id:0) % colorClasses.length];
  };

  const getLetters = () => {
    return (user?.firstName?.charAt(0).toUpperCase() || '') +
      (user?.lastName?.charAt(0).toUpperCase() || '') || 'U';
  };

  const getName = () => {
    return user ? user.lastName ? `${user.firstName} ${user.lastName}` : `${user.email}` : '';
  }

  return (
    <div className="relative group">
      {
        user?.avatarFile ? (
          <img
            src={avatarUrl()}
            alt="Avatar"
            className={(big ? 'w-24 h-24' : 'w-8 h-8') + ' rounded-full border-1 border-indigo-200'}
          />
        ) : (
          <div
            className={(big ? 'w-24 h-24' : 'w-8 h-8') + ` rounded-full border-1 border-indigo-200 ${getColor()} flex items-center justify-center`}
          >
            { big ?
            <span className="text-white text-4xl font-bold">
              {getLetters()}
            </span> 
            : 
            <span className="text-white">
              {getLetters()}
            </span> 
            }             
          </div>
        )
      }
      <Tooltip text={getName()} />
    </div>
  );
}